module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/clipboard-list-d1194f30f6d8ca9886b6a370fbab5011.svg";